export default __webpack_public_path__ + "static/media/snack_bar_black.3121c56c.png";